module.exports = {
    LIMITED: { number: 0, price: 0 },
    PREMIUM: { number: 1, price: 7 },
    PREFERRED: { number: 2, price: 10 }
}